module.exports = __webpack_public_path__ + "img/coin-base.fc8b1795e49adaaaff20e6dd7721e969.jpg";